var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDoNotUseDryer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7.57 7.57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0v7.57h7.57v-7.57zm6.49.62-.9.91a2.82 2.82 0 0 0 -1.81-.67 2.77 2.77 0 0 0 -1.78.68l-.95-.92zm-3.15 3.17-1.34 1.32a2.29 2.29 0 0 1 -.52-1.44 2.26 2.26 0 0 1 .41-1.3zm-1-1.87a2.27 2.27 0 0 1 1.43-.53 2.24 2.24 0 0 1 1.43.52l-1.42 1.43zm1.44 2.3 1.3 1.31a2.24 2.24 0 0 1 -2.61 0zm.43-.44 1.43-1.42a2.24 2.24 0 0 1 -.1 2.74zm-3.59-2.7.92.92a2.77 2.77 0 0 0 .11 3.5l-1 1zm.46 5.92 1-1a2.75 2.75 0 0 0 1.68.57 2.82 2.82 0 0 0 1.69-.57l1 1zm5.92-.51-1-1a2.74 2.74 0 0 0 0-3.49l1-.95z",
    fill: "#313332"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoNotUseDryer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "DoNotUseDryer.eb0b8be11a4e84f0b14b0edf983c6b4b.svg";